import React from "react";
import Button from '@material-ui/core/Button';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  chevronButton: {
    width: "100%",
    "box-sizing": "border-box",
    borderBottom: "1px dashed #CACCD1",
    borderTop: 0,
    borderLeft: 0,
    borderRight: 0,
    margin: "16px 0 0 0",
    display: "inline-flex",
    padding: 0,
    position: "relative",
    "flex-direction": "row",
    "vertical-align": "bottom",
    "justify-content": "left",
    "background-color": "transparent",
    "box-shadow": "none",
    fontSize: 12,
    "text-transform": "none",
    borderRadius: 0,
    lineHeight: "14px"
  }
}));

const ButtonDropDown = ({caption, onClick, arrowUp}) => {
  const { chevronButton } = useStyles();

  return <Button
      className={chevronButton}
      onClick={onClick}
      size="small"
      startIcon={arrowUp ? <ArrowDropUpIcon/> : <ArrowDropDownIcon/>}>
      {caption}
    </Button>
}

export default ButtonDropDown;
